export class OverlayLoaderConfig {
  textDisplay: string = 'Trwa ładowanie...'
  customClass?: string;
}
